module.exports = __webpack_public_path__ + "static/media/22861667_1638432122898639_6413734200275036049_o.5d3e607b.jpg";